import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  countryUnitedKingdom: {
    defaultMessage: 'United Kingdom',
    id: 'UoCfu6',
    description: 'city select country name',
  },
  countryRussia: {
    defaultMessage: 'Russia',
    id: 'c59cvw',
    description: 'city select country name',
  },
  countryFrance: {
    defaultMessage: 'France',
    id: 'y2Zozj',
    description: 'city select country name',
  },
  countryUnitedArabEmirates: {
    defaultMessage: 'United Arab Emirates',
    id: 'Ntc6Zg',
    description: 'city select country name',
  },
  countryUsa: {
    defaultMessage: 'USA',
    id: 'country_name_usa',
    description: 'city select country name',
  },
  countryOther: {
    defaultMessage: 'Other',
    id: 'ZagDol',
    description: 'city select country name',
  },
});
